module.exports = __webpack_public_path__ + "img/2_213.9f8d6363.png";